import { render, staticRenderFns } from "./produtoModal.vue?vue&type=template&id=5cc9a122&"
import script from "./produtoModal.vue?vue&type=script&lang=js&"
export * from "./produtoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports